import { ApolloLink, Operation } from "@apollo/client";
import useMultiRegionStore from "./stores/useMultiRegionStore";

const checkRequiresPin = (operation: Operation) => {
	const context = operation.getContext();
	if (context.pinBehavior === "long") {
		operation.setContext({
			headers: {
				...context.headers,
				"x-pin-behavior": "long",
			},
		});
		return false;
	}
	if (context.pinBehavior === "inert") {
		operation.setContext({
			headers: {
				...context.headers,
				"x-pin-behavior": "inert",
			},
		});
		return false;
	}
	// By default mutations require a pin
	if (
		operation.query.definitions.some(
			(definition) =>
				definition.kind === "OperationDefinition" && definition.operation === "mutation",
		)
	) {
		return true;
	}
	return false;
};

const safeParseInt = (value: string | null | undefined): number | undefined => {
	if (value == null) return undefined;
	const parsed = parseInt(value);
	return isNaN(parsed) ? undefined : parsed;
};

const multiRegionMiddleware = new ApolloLink((operation, forward) => {
	const requiresPin = checkRequiresPin(operation);

	let unsubscribe: (() => void) | undefined;
	const { requestPin, subscribePinHold, setPreferredPinDuration } =
		useMultiRegionStore.getState();
	if (requiresPin) {
		unsubscribe = subscribePinHold();
	}

	return forward(operation).map((response) => {
		const context = operation.getContext();
		const xPinDuration = safeParseInt(context.response?.headers?.get("x-pin-duration"));
		const xForcePinDuration = safeParseInt(
			context.response?.headers?.get("x-force-pin-duration"),
		);
		if (xPinDuration != null) {
			setPreferredPinDuration(xPinDuration);
		}
		if (requiresPin) {
			requestPin();
		}
		if (xForcePinDuration != null) {
			requestPin({ duration: xForcePinDuration });
		}

		unsubscribe?.();
		return response;
	});
});
export default multiRegionMiddleware;
